// Utility for reading files client-side
export class FileReaderUtil {
    /**
     * Reads a file as text
     */
    static readAsText(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = (event) => {
                if (event.target?.result) {
                    resolve(event.target.result);
                }
                else {
                    reject(new Error('Failed to read file'));
                }
            };
            reader.onerror = () => {
                reject(new Error('Error reading file'));
            };
            reader.readAsText(file);
        });
    }
    /**
     * Detects document format from file extension
     */
    static detectFormat(fileName) {
        const extension = fileName.toLowerCase().split('.').pop();
        switch (extension) {
            case 'srt':
                return 'SRT';
            case 'ds':
            case 'txt':
                // Check if it's .ds.txt or just .txt
                if (fileName.toLowerCase().endsWith('.ds.txt')) {
                    return 'AvidDS';
                }
                return 'Text';
            default:
                return 'Unknown';
        }
    }
    /**
     * Validates file size (in MB)
     */
    static validateFileSize(file, maxSizeMB = 50) {
        const fileSizeMB = file.size / (1024 * 1024);
        return fileSizeMB <= maxSizeMB;
    }
    /**
     * Gets a human-readable file size string
     */
    static formatFileSize(bytes) {
        if (bytes === 0)
            return '0 Bytes';
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
    }
}
